import React, {useState} from 'react';
import {Accordion} from '../../Accordion/Accordion';
import {CheckboxStyled, ContentWrapper} from './FolderMetaDataTabPermissions.style';
import {t} from 'i18next';
import {generateIdentifier} from '../../../utils/IdentityUtils';
import {AdvancedRolesPicker} from '../../RolePicker/AdvancedRolesPicker';
import EventEmitter from 'events';
import {FolderMetaDataDialog_changeOwnerRoles, FolderMetaDataDialog_changeRoles} from '../../../init/events';
import {getOwnerRoles, getUserRoles} from '../../../utils/UserUtils';

export interface FolderMetaDataTabPermissionsProps {
    readonly isPublic: boolean;
    readonly roles?: string[];
    readonly ownerRoles?: string[];
    readonly rolesDataSource: string[];
    readonly parentOwnerRoles: string[];
    readonly parentRoles: string[];
    readonly eventEmitter: EventEmitter;
}

/**
 * @name FolderMetaDataTabPermissions
 * @description
 * The dialog to add the metadata of a newly created folder or edited folder - Metadata Tabs
 */
export const FolderMetaDataTabPermissions: React.VFC<FolderMetaDataTabPermissionsProps> = (props) => {
    const [isPublicInput] = useState<boolean>(props.isPublic ?? false);
    const [rolesInput, setRolesInput] = useState<string[]>(getUserRoles(props.roles));
    const [ownerRolesInput, setOwnerRolesInput] = useState<string[]>(getOwnerRoles(props.ownerRoles));
    const [rolesDataSource] = useState<string[]>(getUserRoles(props.rolesDataSource));
    const [ownerRolesDataSource] = useState<string[]>(getOwnerRoles(props.rolesDataSource));
    const [parentOwnerRolesInput] = useState(getOwnerRoles(props.parentOwnerRoles));
    const [parentRolesInput] = useState(getUserRoles(props.parentRoles));

    const handleRoles = (userRoles: string[]) => {
        setRolesInput(userRoles);
        props.eventEmitter.emit(FolderMetaDataDialog_changeRoles, userRoles);
    };
    const handleOwnerRoles = (ownerRoles: string[]) => {
        setOwnerRolesInput(ownerRoles);
        props.eventEmitter.emit(FolderMetaDataDialog_changeOwnerRoles, ownerRoles);
    };

    return (
        <ContentWrapper id={generateIdentifier()}>
            <Accordion accordionHeadline={t('CREATE_EDIT_FOLDER_DIALOG_ACCORDION_TITLE_ROLES')}
                       startOpen>
                <CheckboxStyled id={generateIdentifier('IsPublic')}
                                key={'IsPublic'}
                                label={t('PUBLIC_ACCESS')}
                                checked={isPublicInput}
                                disabled={true}/>
                <AdvancedRolesPicker dataSource={rolesDataSource}
                                     roles={rolesInput}
                                     parentRoles={parentRolesInput}
                                     onChange={handleRoles}/>
            </Accordion>
            <Accordion accordionHeadline={t('CREATE_EDIT_FOLDER_DIALOG_ACCORDION_TITLE_OWNER_ROLES')}
                       startOpen>
                <AdvancedRolesPicker dataSource={ownerRolesDataSource}
                                     roles={ownerRolesInput}
                                     parentRoles={parentOwnerRolesInput}
                                     onChange={handleOwnerRoles}/>
            </Accordion>
        </ContentWrapper>
    );
}